export type AuthErrorType =
  | 'accountAlreadyExists'
  | 'doesNotMatchRules'
  | 'noAccountFound'
  | 'unknown';

export interface AuthError {
  type: AuthErrorType;
  message?: string;
  originalError?: string; // For debugging purposes
  correlationId?: string; // Parsed from B2C error description
  timestamp?: string; // Parsed from B2C error description
}

export class AuthenticationError extends Error {
  public readonly authError: AuthError;
  public readonly action?: string;

  constructor(authError: AuthError, action?: string) {
    const message = `Authentication Error [${authError.type}]: ${authError.message ||
      'Authentication failed'}`;
    super(message);

    this.name = 'AuthenticationError';
    this.authError = authError;
    this.action = action;

    // Ensure proper prototype chain for instanceof checks
    Object.setPrototypeOf(this, AuthenticationError.prototype);
  }

  // Helper method to get custom attributes for New Relic
  getCustomAttributes() {
    return {
      errorType: this.authError.type,
      correlationId: this.authError.correlationId,
      originalError: this.authError.originalError,
      action: this.action,
      customMessage: this.authError.message,
    };
  }
}
